import { useStatsigClient } from '@statsig/react-bindings';
import { StatsigABTestDataType } from '../../constants/ab-tests/ab-tests';
import { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import getAssignedVariant from '../../utils/statsig/get-assigned-variant';
import serializeQueryParams from '../../utils/url/serialize-query-params';
import useDevice from '../use-device';

// isEligible: the test's eligibility condition, recorded for the quality events (see src/constants/CLAUDE.md).
// needsInitTest: false ⇒ the test is neither read nor recorded as an eligibility, for a test whose population
// Statsig decides and which is read only while its surface can show
const useStatsigVariant = (props: StatsigABTestDataType, isEligible?: boolean, needsInitTest = true): string => {
    const { statsigKey, layerName, limitedWorlds, allowedDevices } = props;

    const queryParams = serializeQueryParams() as Record<string, string | undefined>;
    const { getExperiment, getLayer } = useStatsigClient();
    const device = useDevice();

    if (!needsInitTest || (limitedWorlds !== undefined && !limitedWorlds.includes(world as AVAILABLE_WORLDS))) {
        return '';
    }

    if (allowedDevices !== undefined && !allowedDevices.includes(device)) {
        return '';
    }

    recordEligibility(statsigKey, isEligible);

    if (isEligible === false) {
        return '';
    }

    if (queryParams[statsigKey]) {
        return queryParams[statsigKey] as string;
    }

    const statsigSource = layerName ? getLayer(layerName) : getExperiment(statsigKey);
    const variant = getAssignedVariant({
        source: statsigSource,
        statsigKey,
        variant: statsigSource.get(statsigKey, '') as string
    });

    if (!window.statsigVariant) {
        window.statsigVariant = {};
    }

    window.statsigVariant[statsigKey] = () => {
        return variant;
    };

    return variant;
};

const recordEligibility = (statsigKey: string, isEligible?: boolean) => {
    const hasEligibilityCondition = isEligible !== undefined;

    if (!hasEligibilityCondition) {
        return;
    }

    if (!window.statsigEligibility) {
        window.statsigEligibility = {};
    }

    window.statsigEligibility[statsigKey] = isEligible;
};

export default useStatsigVariant;
